
import { defineComponent, ref } from "vue";
import { getCSSVariableValue } from "../../assets/ts/_utils";
/* import { Home } from "@/store/enums/StoreEnums"; */
import { useStore } from "vuex";
import ApexCharts from "apexcharts";
import { convertToMoney } from "@/utils/stringUtils";

interface Data {
  name: string;
  group: string;
  data: number[];
}
interface Yaxis {
  seriesName: string;
  show: boolean;
  opposite: boolean;
  labels: {
    style: {
      colors: string;
      fontSize: string;
    };
    formatter: (value: string) => string;
  };
  tickAmount: number;
  title: {
    text: string;
    rotate: number;
  };
}
interface Formatter {
  formatter: (value: string) => string;
}

export default defineComponent({
  name: "ChartTest",
  props: {
    widgetClasses: String,
  },
  components: {},
  setup() {
    const labelColor = getCSSVariableValue("--bs-gray-500cc");
    const borderColor = getCSSVariableValue("--bs-gray-500");
    const baseColor = getCSSVariableValue("--bs-success");
    const secondaryColor = getCSSVariableValue("--bs-primary");
    const store = ref(useStore());
    const chart = ref<ApexCharts>();

    const month = ref<string[]>([]);

    const options = ref({
      chart: {
        fontFamily: "inherit",
        height: 350,
        toolbar: {
          show: false,
        },
        stacked: true,
      },
      colors: [
        baseColor,
        secondaryColor,
        /* "#65E6A0",
        "#58A6F5",
        "#58F55D",
        "#5875F5",
        "#D1F546",
        "#47D4F5", */
      ],
      legend: {
        show: true,
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["#fff"],
      },

      xaxis: {
        categories: [],
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          style: {
            colors: labelColor,
            fontSize: "12px",
          },
        },
      },
      yaxis: [],
      fill: {
        opacity: 1,
      },
      states: {
        normal: {
          filter: {
            type: "none",
            value: 0,
          },
        },
        hover: {
          filter: {
            type: "none",
            value: 0,
          },
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: "none",
            value: 0,
          },
        },
      },
      tooltip: {
        style: {
          fontSize: "12px",
        },
      },
      grid: {
        borderColor: borderColor,
        strokeDashArray: 4,
        /* xaxis: {
          lines: {
            show: true,
          },
        }, */
        yaxis: {
          lines: {
            show: true,
          },
        },
      },
    });

    const series = ref<Data[]>([]);
    const yaxis = ref<Yaxis>({
      seriesName: "",
      show: true,
      opposite: false,
      labels: {
        style: {
          colors: labelColor,
          fontSize: "12px",
        },
        formatter: (value) => {
          return convertToMoney(value);
        },
      },
      tickAmount: 7,
      title: {
        text: "(vnd)",
        rotate: -45,
      },
    });

    return {
      options,
      series,

      month,
      store,
      chart,
      labelColor,
      yaxis,
    };
  },
  methods: {
    handleProcessData(data) {
      this.series = [] as Data[];
      const formatter = [] as Formatter[];
      const yaxis = [] as Yaxis[];
      const length = data.length;
      let type = [] as string[];
      for (let i = 0; i < length; i++) {
        if (!type.includes(data[i].cDoiTuongGia)) {
          type.push(data[i].cDoiTuongGia);
        }
      }
      for (let n = 0; n < type.length; n++) {
        let seriesData = data.filter((a) => a.cDoiTuongGia == type[n]);
        let m = 0;
        for (let prop in seriesData[m]) {
          if (prop == "nTongTien" || prop == "nSanLuong") {
            let name = "";
            switch (prop) {
              case "nTongTien":
                name = "Tổng Tiền";
                formatter.push({
                  formatter: function (val) {
                    return convertToMoney(val) + " vnd";
                  },
                });
                yaxis.push({
                  ...this.yaxis,
                  seriesName: name + " " + type[0],
                  show: n == 0,
                  title: {
                    text: "(vnd)",
                    rotate: -45,
                  },
                });
                break;
              case "nSanLuong":
                name = "Sản Lượng";
                formatter.push({
                  formatter: function (val) {
                    return convertToMoney(val) + " m3";
                  },
                });
                yaxis.push({
                  ...this.yaxis,
                  seriesName: name + " " + type[0],
                  opposite: true,
                  show: n == 0,
                  title: {
                    text: "(m3)",
                    rotate: 45,
                  },
                });
                break;
              default:
                name = "";
                break;
            }
            let Data = {
              name: name + " " + type[n],
              group: prop,
              data: [] as number[],
            } as Data;
            for (m = 0; m < seriesData.length; m++) {
              Data.data.push(parseFloat(seriesData[m][prop]));
            }
            this.series.push(Data);
          } else if (prop == "cThang") {
            for (m = 0; m < length; m++) {
              let month = data[m][prop].split("/");
              if (!this.month.includes("Tháng " + parseInt(month[1])))
                this.month.push("Tháng " + parseInt(month[1]));
            }
          }
          m = 0;
        }
      }
      this.handleUpdateChartOption(yaxis, formatter);
    },
    handleUpdateChartOption(yaxis, formatter) {
      this.chart?.updateOptions({
        xaxis: {
          categories: this.month,
        },
        yaxis: yaxis,
        tooltip: {
          y: formatter,
        },
      });
    },
/*     handleFindRecent6MonthsDataByUserGroup() {
      this.store.dispatch(Home.findAppInfo).then((res) => {
        if (res.code == 200) {
          let data = JSON.parse(res.data);
          this.handleProcessData(data);
        }
      });
    }, */
  },
/*   mounted() {
    this.handleFindRecent6MonthsDataByUserGroup();
  }, */
});
